// src/features/marketResearch/services/marketResearchService.ts
import { api } from '@services';
import { ExtendedMarketResearch } from '../types';

export const fetchMarketResearchAPI = async (hotelId: string) => {
  const resp = await api.get<ExtendedMarketResearch[]>(`/market-research/${hotelId}/market-analysis`);
  return resp.data;
};

export const generateMarketResearchAPI = async (hotelId: string) => {
  const resp = await api.post<ExtendedMarketResearch>(`/market-research/${hotelId}/market-analysis`, {
    marketParams: {
      additionalContext:
        'Provide a comprehensive, detailed analysis on the market for the hotel size and location. Include thorough analysis of competitive landscape, market trends, economic factors, and detailed recommendations.',
    },
  });
  return {
    ...resp.data,
    createdAt: resp.data.created_at || resp.data.createdAt || new Date().toISOString(),
  };
};

export const deleteMarketResearchAPI = async (hotelId: string, reportId: string | number) => {
  await api.delete(`/market-research/${hotelId}/market-analysis/${reportId}`);
};
